import { Box, Stack, Typography } from '@mui/material';
import { getIn } from 'formik';

import {
  FormAutocompleteField,
  FormFieldReadOnlyValue,
  FormNumberField,
  LIST_ROW_BG_SX,
  LIST_ROW_BORDER_SX,
} from '../../../../../common';
import { TREATMENT_SERVICE_FREQUENCY_OPTIONS } from '../constants';
import { TREATMENT_SERVICE_LABEL_SX, TREATMENT_SERVICE_ROW_SX } from '../styles';
import { getTreatmentServiceUnits } from '../utils';

import type { TreatmentServiceRowProps } from './types';

export default function TreatmentServiceRow({
  formik,
  disabled,
  readOnly,
  saveField,
  row,
  index,
}: TreatmentServiceRowProps) {
  return (
    <Stack
      alignItems={{ md: 'flex-start' }}
      direction={{ xs: 'column', md: 'row' }}
      sx={[TREATMENT_SERVICE_ROW_SX, LIST_ROW_BORDER_SX, LIST_ROW_BG_SX[index % 2]]}
    >
      <Typography sx={TREATMENT_SERVICE_LABEL_SX}>{row.label}</Typography>
      <Box flex={1}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          inputAriaLabel={`${row.label} hours`}
          label="Hours"
          max={row.maxHours}
          maxDecimalPlaces={0}
          min={0}
          name={row.hoursName}
          onBlur={saveField}
          placeholder="Enter hours"
          readOnly={readOnly}
        />
      </Box>
      <Box flex={1}>
        <FormFieldReadOnlyValue
          label="Units"
          value={getTreatmentServiceUnits(getIn(formik.values, row.hoursName))}
        />
      </Box>
      <Box flex={1}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          inputAriaLabel={`${row.label} per`}
          label="Per"
          name={row.perName}
          onChange={saveField}
          options={TREATMENT_SERVICE_FREQUENCY_OPTIONS}
          placeholder="Select how often"
          readOnly={readOnly}
          required
        />
      </Box>
    </Stack>
  );
}
